import React from 'react';
import { FaHeart, FaCut, FaBug, FaPaw, FaTooth } from 'react-icons/fa';
import { GiComb } from 'react-icons/gi';
import './AdditionalServices.scss';

const AdditionalServices: React.FC = () => {
  return (
    <section id="additional-services" className="additional-services-section">
      <div className="container">
        <div className="additional-services-header">
          <h2 className="additional-services-title">
            <span className="highlight-text">ADDITIONAL</span> SERVICES
          </h2>
          <p className="additional-services-subtitle">
            Extra care and specialized treatments to keep your pet healthy and comfortable.
          </p>
        </div>
        
        <div className="additional-services">
          <div className="service-card">
            <div className="service-icon">
              {FaHeart({ size: 32 })}
            </div>
            <h3 className="service-title">Special Care</h3>
            <p className="service-price">Starts at $25</p>
            <p className="service-description">Applies to pets that may be aggressive, difficult to handle, or require extra care due to special medical or age-related needs.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              {FaCut({ size: 32 })}
            </div>
            <h3 className="service-title">Dematting</h3>
            <p className="service-price">Starts at $20</p>
            <p className="service-description">Depending on severity and time spent.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              {FaBug({ size: 32 })}
            </div>
            <h3 className="service-title">Flea/Tick Treatment</h3>
            <p className="service-price">$40</p>
            <p className="service-description">Fast acting and long-lasting flea and tick treatment</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              {FaPaw({ size: 32 })}
            </div>
            <h3 className="service-title">Nail Clipping/Dremelling</h3>
            <p className="service-price">$10</p>
            <p className="service-description">Professional nail trimming and filing for your pet's comfort and health.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              {FaTooth({ size: 32 })}
            </div>
            <h3 className="service-title">Teeth Brushing + Spray</h3>
            <p className="service-price">$10</p>
            <p className="service-description">Complete dental care with brushing and fresh breath spray for oral hygiene.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              {GiComb({ size: 32 })}
            </div>
            <h3 className="service-title">Deshedding</h3>
            <p className="service-price">$20</p>
            <p className="service-description">Specialized treatment to reduce excessive shedding and keep your home cleaner.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdditionalServices;
